import {calculateAllPraemien, getPraemienInUse, productKeyFromCategories} from "@/helper/praemienHelper";
import httpService from "@/helper/httpService";
import {INIT_PRAEMIEN} from "@/store/actionTypes";
import {RIGHTS} from "@/store/user";
import {getDateWithTimeString} from "@/helper/dateService";

function getInitialMvp() {
  return  {
    rolle: "Mitzuversichernder Lebenspartner",
    unused: ["email", "telefon", "mobil", "staat", "plz", "ort", "strasse"],
    anrede: "kA",
    titel: "",
    firstname: "",
    lastname: "",
    geburt: "",
    beruf: null,
    hasvorversicherung: null,
    anzahlvorversicherungen: 1,
    vorversicherung: [
      {
        zum: null,
        vorversicherer: "",
        vscheinnr: "",
        von: null
      },
      {
        zum: null,
        vorversicherer: "",
        vscheinnr: "",
        von: null
      },
      {
        zum: null,
        vorversicherer: "",
        vscheinnr: "",
        von: null
      }
    ],
    hasRechtsstreitigkeiten: null,
    anzahlRechtsstreitigkeiten: null,
    leistungshoeheRechtsstreitigkeiten: null,
    hasAnwaltsbesuche: null,
    anzahlAnwaltsbesuche: null,
    leistungshoeheAnwaltsbesuche: null,
    streitAktuell: null,
    anwaltGeplant: null
  };
}

function getInitialState() {
  return {
    submitTime: null,

    // PKS
    selectedIdentity: {
      metadata: {
        firstname: "",
        lastname: ""
      },
      username: "",
      vmnr: "",
      tarifname: ""
    },
    selectedTarif: "",
    fremdangebot: false,
    coupon: "",
    couponby: "",
    plzalter: "",

    // created angebot
    angebotsnummer: '',
    guid: '',
    pdfpfad: '',

    //step1
    civilServant: false,
    categories: [],
    family: 'MPH',
    contractlength: '1',
    sus: false,

    trafficType: 'Familie',
    car1license: '',
    car2license: '',
    car3license: '',
    car4license: '',
    car5license: '',
    showkfz: 0,

    // step2
    rabattProzent: 0, // n = n%
    oekopunkte: 0,

    yoligekfz: false,
    yoligazubi: false,
    yoligrentner: false,
    nurnachhaltig: false,

    ssrselected: false,
    ssrdisabled: true,
    ssrsb: 'SB150',

    cyberselected: false,
    cyberdisabled: false,
    cybersb: 'SB150',

    zwselected: false,
    zwdisabled: true,
    zweitwohnung: {
      id: "Zweitwohnung",
      beschreibung: "Zweitwohnung",
      strasse: "",
      hausnummer: "",
      ort: "",
      plz: "",
      bruttojahresmiete: "",
      land: "",
      sb: ""
    },

    vermselected: false,
    vermdisabled: false,
    vermwohnungen: [{
      id: "Wohneinheit 1",
      beschreibung: "Wohneinheit 1",
      strasse: "",
      hausnummer: "",
      ort: "",
      plz: "",
      land: "Deutschland",
      sb: "SB300",
      bruttojahresmiete: null,
      hasError: true
    }],
    vermvalid: false,

    //STD EXP PRE
    productLine: '',
    //"SB100", "SB300", "SB0"
    sb: '',
    tmpMatrixState: {
      family: 'MPH',
      contractlength: '1',
      categories: [],
      ssrselected: false,
      sb: "",
      productLine: "",
      sus: false
    },

    //step3
    vn: {
      rolle: "Antragsteller",
      anrede: "kA",
      titel: "",
      firstname: "",
      lastname: "",
      strasse: "",
      hausnummer: "",
      adresszusatz: "",
      plz: "",
      ort: "",
      geburt: "",
      beruf: null, //values bound to v-select controls should be initialized with null, for correct label placement
      email: "",
      kommunikationEmail: true,
      mobil: "",
      telefon: "+49",
      staat: "Deutschland",
      hasvorversicherung: null,
      anzahlvorversicherungen: 1,
      vorversicherung: [
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        },
        {
          zum: null,
          vorversicherer: "",
          vscheinnr: "",
          von: null
        }
      ],
      hasRechtsstreitigkeiten: null,
      anzahlRechtsstreitigkeiten: null,
      leistungshoeheRechtsstreitigkeiten: null,
      hasAnwaltsbesuche: null,
      anzahlAnwaltsbesuche: null,
      leistungshoeheAnwaltsbesuche: null,
      streitAktuell: null,
      anwaltGeplant: null
    },
    mvp:getInitialMvp(),
    kontoinhaber: {
      rolle: "Kontoinhaber",
      unused: ["beruf", "email", "telefon", "mobil", "staat", "geburt"],
      anrede: "kA",
      titel: "",
      firstname: "",
      lastname: "",
      strasse: "",
      hausnummer: "",
      adresszusatz: "",
      plz: "",
      ort: "",
      geburt: ""
    },

    iban: "",
    bic: "",
    inhabertyp: "VN",
    rechnungszahler: "N",
    zahlweise: "1",


    //step4
    versicherungsbeginn: null,
    versicherungsbeginnVergangenheit: false,
    hauptfaelligkeit: null,
    aula: "J",
    invitatio: false,
    werbezwecke: null,
    anmerkungen: "",
    files: [],
    fileIds: [],
    maknummer: ""

  };
}

function getStateRef(rootState, statePath) {
  let stateRef = rootState;
  let aStatePath = statePath.split('.');
  while (aStatePath.length > 0) {
    stateRef = stateRef[aStatePath.shift()];
  }
  return stateRef;
}

const state = getInitialState();

const getters = {
  rabatt: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      // rabattProzent and oekopunkte can only be used excusively.
      return state.rabattProzent ? state.rabattProzent : state.oekopunkte;
    };
  },
  /**
   * Anzahl Fahrzeuge im Privat Fahrzeug-RS (min = 1)
   * @returns
   */
  anzahlFahrzeugRS: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      return state.showkfz ? (+state.showkfz + 1) : 1;
    };
  },
  /**
   * Test if the user already has entered an valid produkt
   * and return the corresponding key
   * @returns
   */
  productKey: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      if (state.sus) {
        return "S&S PBVW+SSR";
      }
      let key = productKeyFromCategories(state.categories);

      if (key === "V") {
        switch (state.trafficType) {
          case "Familie":
            key = "V-Familie";
            break;
          case "Versicherungsnehmer":
            key = "V-VN";
            break;
          case "Fahrer":
            key = "Fahrer";
            break;
          case "Fahrzeug":
            key = "FzRS";
            break;
          default:
            key = "";
        }
      }
      return key;
    };
  },
  /**
   * Does the Produkt require an MVP
   */
  hasMvp: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let sRet = "true";
      let sProduct = getters.productKey(statePath);
      if (sProduct === "V-VN" || sProduct === "V-Familie" || sProduct === "Fahrer" || sProduct === "FzRS") {
        sRet = false;
      }
      if (state.family === "EPH") {
        sRet = false;
      }

      return sRet;
    };
  },
  familyStatus: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let ret = 'Unbekannt';
      switch (state.family) {
        case 'EPH':
          ret = 'Einpersonhenhaushalt';
          break;
        case 'MPH':
          ret = 'Mehrpersonenhaushalt';
          break;
      }
      return ret;
    };
  },

  getContractLength: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      return state.contractlength;
    };
  },

  /**
   * Returns function to translate keys to Text TODO maybe put all translater functions in a mixin instead
   * @returns {function} (key) returns Text
   */
  productLineText: (state, getters, rootState) => {
    return function (key, tarif) {
      switch (key) {
        case "STD": {
          // TODO extract definition of single column tarifs, used here and in price matrix
          const singleColumnTarifs = ["web", "comfortplan", "mv", "mvmg", "securo", "securoplus", "securopremium"];
          if (singleColumnTarifs.includes(tarif)) {
            const tarifDefinition = rootState.praemien.tarifList.find(tarifFromList => tarifFromList.value === tarif);
            return tarifDefinition.text;
          } else {
            return "Standard";
          }
        }
        case "EXP":
          return "EXPERT";
        case "PRE":
          return "PRESTIGE";
        case "YOL":
          return "YOLIG";
        default:
          return key;
      }
    };
  },
  getProductText: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let productnames = [];
      //Order matters !
      if (state.categories.includes("P")) {
        productnames.push("Privat");
      }
      if (state.categories.includes("B")) {
        productnames.push("Beruf");
      }
      if (state.categories.includes("V")) {
        let trafficType = "Verkehr";
        if (state.categories.length === 1 && state.trafficType) {
          switch (state.trafficType) {
            case "Familie":
              trafficType = "alle auf die Familie zugelassenen Kfz";
              break;
            case "Versicherungsnehmer":
              trafficType = "alle auf den Versicherungsnehmer zugelassenen Kfz";
              break;
            case "Fahrzeug":
              trafficType = "Fahrzeug-Rechtsschutz";
              break;
            case "Fahrer":
              trafficType = "Fahrer-Rechtsschutz";
              break;
          }
        }
        productnames.push(trafficType);
      }
      if (state.categories.includes("W")) {
        productnames.push("Wohnen");
      }
      if (state.categories.includes("M")) {
        productnames.push("Mietrechtsschutz vor Gericht");
      }
      if (productnames === []) {
        productnames.push("Unbekannt");
      }
      return productnames.join(", ");
    };
  },
  getSb: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let sb = -1;
      switch (state.sb) {
        case "SB150":
          sb = 150;
          break;
        case "SB300":
          sb = 300;
          break;
        case "SB500":
          sb = 500;
          break;
        case "SB0":
          sb = 0;
          break;
        default:
          sb = -1;
      }
      return sb;
    };
  },
  /**
   * For tarif charta, SB0 is ouput aus SB50. Calculation stays the same.
   * */
  tarifIsCharta: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let tarif = state.selectedTarif ? state.selectedTarif : rootState.user.tarifname;
      return tarif === 'charta';
    };
  },
  getSecuroFaktor: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      if (state.selectedTarif && !/securo/.test(state.selectedTarif)) {
        //console.log("Tarif force securoFaktor to 1");
        return 1.0;
      }
      let plzalter = state.plzalter ? state.plzalter : '';
      if (!plzalter) {
        //console.log("plzalter force securoFaktor to 1");
        return 1.0;
      } else {
        const factors = {P1A1:0.760,P2A1:0.800,P3A1:0.840,P4A1:0.904,P5A1:1.000,P1A2:0.855,P2A2:0.900,P3A2:0.945,P4A2:1.017,P5A2:1.125,P1A3:0.979,P2A3:1.030,P3A3:1.082,P4A3:1.164,P5A3:1.288,P1A4:0.998,P2A4:1.050,P3A4:1.103,P4A4:1.187,P5A4:1.313,P1A5:1.045,P2A5:1.100,P3A5:1.155,P4A5:1.243,P5A5:1.375,P1A6:1.069,P2A6:1.125,P3A6:1.181,P4A6:1.271,P5A6:1.406,P1A7:0.950,P2A7:1.000,P3A7:1.050,P4A7:1.130,P5A7:1.250,P1A8:0.855,P2A8:0.900,P3A8:0.945,P4A8:1.017,P5A8:1.125,P1A9:0.760,P2A9:0.800,P3A9:0.840,P4A9:0.904,P5A9:1.000};
        let securoFaktor = factors[plzalter];
        if( plzalter && !securoFaktor){
          return 1.0;
        } else {
          console.log("securoFaktor", securoFaktor);
          return securoFaktor;
        }
      }
    };
  },
  getSsrSb: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let ret = 0.0;
      switch (state.ssrsb) {
        case "SB150":
          ret = 150;
          break;
        case "SB300":
          ret = 300;
          break;
        case "SB500":
          ret = 500;
          break;
      }
      return ret;
    };
  },
  // not reusing customPraemien to utilize vuex getter caching - as soon as we can get rid of the statePath parameter
  currentPraemien: (state, getters, rootState) => statePath => {
    state = getStateRef(rootState, statePath);
    const calculatedPraemien = calculateAllPraemien({
        rawPraemien: getters.rawPraemien,
        mainproduktKey: getters.productKey(statePath),
        produktlinie: state.productLine,
        haushalt: state.family,
        beamter: state.civilServant ? "B" : "N",
        sb: state.sb,
        cybersb: state.cybersb,
        ssrsb: state.ssrsb,
        laufzeit: state.contractlength,
        zahlweise: state.zahlweise,
        maklerRabatt: getters.rabatt(statePath),
        vermwohnungen: state.vermwohnungen,
        multiplier: { "FzRS": getters.anzahlFahrzeugRS(statePath) },
        yoligrentner: state.yoligrentner,
        yoligazubi: state.yoligazubi,
        yoligekfz: state.yoligekfz,
        securoFaktor: getters.getSecuroFaktor(statePath) 
      }
    );

    return getPraemienInUse(calculatedPraemien, {
        useSsr: !state.ssrdisabled && state.ssrselected,
        useCyber: !state.cyberdisabled && state.cyberselected,
        useZweitwohnung: !state.zwdisabled && state.zwselected,
        useVermieter: !state.vermdisabled && state.vermselected
      }
    );
  },
  customPraemien: (state, getters, rootState) => statePath => (zahlweise, laufzeit, maklerRabatt, useFlags) => {

    state = getStateRef(rootState, statePath);

    const calculatedPraemien = calculateAllPraemien({
        rawPraemien: getters.rawPraemien,
        mainproduktKey: getters.productKey(statePath),
        produktlinie: state.productLine,
        haushalt: state.family,
        beamter: state.civilServant ? "B" : "N",
        sb: state.sb,
        cybersb: state.cybersb,
        ssrsb: state.ssrsb,
        laufzeit: laufzeit !== undefined ? laufzeit : state.contractlength,
        zahlweise: zahlweise !== undefined ? zahlweise : state.zahlweise,
        maklerRabatt: maklerRabatt !== undefined ? maklerRabatt : getters.rabatt(statePath),
        vermwohnungen: state.vermwohnungen,
        multiplier: {"FzRS": getters.anzahlFahrzeugRS(statePath)},
        yoligrentner: state.yoligrentner,
        yoligazubi: state.yoligazubi,
        yoligekfz: state.yoligekfz,
        securoFaktor: getters.getSecuroFaktor(statePath)
      }
    );

    return getPraemienInUse(calculatedPraemien, useFlags || {
      useSsr: !state.ssrdisabled && state.ssrselected,
      useCyber: !state.cyberdisabled && state.cyberselected,
      useZweitwohnung: !state.zwdisabled && state.zwselected,
      useVermieter: !state.vermdisabled && state.vermselected
    }
    );
  },
  /**
   * Get id of the tarif to load for this offer.
   * Returns null for everyone apart from PKS users.
   * For PKS users the id of the selected tarif is returned.
   */
  tarifToLoad(state, getters) {
    return getters.checkAuthorization(RIGHTS.TARIFSELECTION) && state.selectedTarif ? state.selectedTarif : null;
  },
  activeTarif(state, getters, rootState) {
    return state.selectedTarif ? state.selectedTarif : rootState.user.tarifname;
  },
  getCategoriesLength(state, getters, rootState) {
    return statePath => {
      state = getStateRef(rootState, statePath);
      return state.categories.length;
    };
  },
  showYoligMatrix(state, getters, rootState) {
    return statePath => {
      state = getStateRef(rootState, statePath);
      const basetarif = getters.activeTarif;
      if (basetarif != 'basis' && basetarif != 'pool') return false;
      const baseprod = getters.productKey(statePath);
      if (/PBVW|PBV|PBW|PVW|PB|PV/.test(baseprod)) return true;
      return false;
    };
  },
  showYoligOnly(state, getters, rootState) {
    return statePath => {
      state = getStateRef(rootState, statePath);
      const basetarif = getters.activeTarif;
      if (basetarif != 'basis' && basetarif != 'pool') return false;
      const baseprod = productKeyFromCategories(state.categories);
      if (/PBVW|PBV|PBW|PVW|PB|PV/.test(baseprod)) return true;
      return false;
    };
  },
  needsProfessionalDriversWarning: (state, getters, rootState) => {
    return statePath => {
      state = getStateRef(rootState, statePath);
      let sb = getters.getSb(statePath);
      return state.categories.length === 1 && state.categories.indexOf('V') > -1
        && sb > -1 && sb < 300;
    };
  },
  premiumMinimum(state, getters, rootState) {
    let tarif = state.selectedTarif ? state.selectedTarif : rootState.user.tarifname;
    return (["securo", "securoplus", "securopremium"]).includes(tarif) ? 0 : 15;
  }

};

const mutations = {
  setAngebot: function (state, { rootState, statePath, angebot }) {
    state = getStateRef(rootState, statePath);
    state.angebotsnummer = angebot.angebotsnummer;
    state.guid = angebot.guid;
    state.pdfpfad = angebot.pdfpfad;
    state.submitTime = angebot.submitTime;
  },
  deselectProdukt: function (state, { rootState, statePath }) {
    state = getStateRef(rootState, statePath);
    state.sb = null;
    state.sus = false;
    state.productLine = null;
    state.price = null;
    state.matrixSelection = "";
    state.ssrdisabled = true;
    state.ssrselected = false;
    state.cyberdisabled = true;
    state.cyberselected = false;
    state.zwdisabled = true;
    state.zwselected = false;
    state.vermdisabled = true;
    state.vermselected = false;
  },

  addInitialWohnung: function (state, { rootState, statePath }) {
    state = getStateRef(rootState, statePath);
    const id = "Wohneinheit " + (state.vermwohnungen.length + 1);
    const wohnung = {
      id,
      beschreibung: id,
      strasse: "",
      hausnummer: "",
      ort: "",
      plz: "",
      land: "Deutschland",
      sb: state.vermwohnungen.length === 0 ? "SB300" : state.vermwohnungen[0].sb,
      bruttojahresmiete: null,
      hasError: true
    };
    state.vermwohnungen.push(wohnung);
    state.vermvalid = false;
  },

  removeWohnung: function (state, { rootState, statePath }) {
    state = getStateRef(rootState, statePath);
    state.vermwohnungen.pop();
    state.vermvalid = true;
    for (let i = 0; i < state.vermwohnungen.length; i++) {
      if (state.vermwohnungen[i].hasError) {
        state.vermvalid = false;
      }
    }
  },

  privatCleanupPersonData: (state) => {
    // cleanup step 3
    if (state.rechnungszahler === "J" || state.rechnungszahler === "M") {
      state.iban = "",
      state.bic = "",
      state.inhabertyp = "VN",
      state.kontoinhaber.anrede = "kA";
      state.kontoinhaber.titel = "";
      state.kontoinhaber.firstname = "";
      state.kontoinhaber.lastname = "";
      state.kontoinhaber.strasse = "";
      state.kontoinhaber.hausnummer = "";
      state.kontoinhaber.adresszusatz = "";
      state.kontoinhaber.plz = "";
      state.kontoinhaber.ort = "";
      state.kontoinhaber.geburt = "";
    }
    if (state.family === "EPH" ) {
      state.mvp = getInitialMvp(); 
    }
  },
    privatCleanupVorverData: (state) => {
    // cleanup step 4
    if (state.vn.hasAnwaltsbesuche !== "J") {
      state.vn.leistungshoeheAnwaltsbesuche = null;
      state.vn.anzahlAnwaltsbesuche = null;
    }
    if (state.vn.hasRechtsstreitigkeiten !== "J" ) {
      state.vn.leistungshoeheRechtsstreitigkeiten = null;
      state.vn.anzahlRechtsstreitigkeiten = null;
    }
    if (state.mvp) {
      if (state.mvp.hasAnwaltsbesuche !== "J") {
        state.mvp.leistungshoeheAnwaltsbesuche = null;
        state.mvp.anzahlAnwaltsbesuche = null;
      }
      if (state.mvp.hasRechtsstreitigkeiten !== "J" ) {
        state.mvp.leistungshoeheRechtsstreitigkeiten = null;
        state.mvp.anzahlRechtsstreitigkeiten = null;
      }
    }
  },
  updateWohnung: function (state, { rootState, statePath, payload }) {
    //payload = {index: number,
    //          data: Object}
    state = getStateRef(rootState, statePath);
    Object.assign(state.vermwohnungen[payload.index], payload.data);
    state.vermvalid = true;
    for (let i = 0; i < state.vermwohnungen.length; i++) {
      if (state.vermwohnungen[i].hasError) {
        state.vermvalid = false;
      }
    }
  },

  updateWohnungenSbs: function (state, { rootState, statePath, payload }) {
    //payload = {sb: string}
    state = getStateRef(rootState, statePath);
    for (let i = 0; i < state.vermwohnungen.length; i++) {
      state.vermwohnungen[i].sb = payload.sb;
    }
  },

  /**
   * if product and productline is selected contol
   * ...disable, ...selected state of zusatzbausteine
   */
  refreshZusatzbausteine: function (state, { rootState, statePath }) {

    //general rules
    state = getStateRef(rootState, statePath);
    let disableAll = false;

    // no Zusatzbausteine when product line is not selected, or standard is selected
    if (!state.productLine || state.productLine === "STD") {
      disableAll = true;
    }
    // Zusatzbausteine only available for Privat + X
    if (!(this.getters.productKey(statePath).length > 1 && this.getters.productKey(statePath).match(/\bP\w+\b/))) {
      disableAll = true;
    }

    // Zusatzbausteine only available for defined set of tarife
    if (!["basis", "pool", "charta"].includes(this.getters.activeTarif)) {
      disableAll = true;
    }

    if (disableAll) {
      state.ssrdisabled = true;
      state.cyberdisabled = true;
      state.zwdisabled = true;
      state.vermdisabled = true;
    } else {
      state.ssrdisabled = false;
      state.cyberdisabled = false;
      state.zwdisabled = false;
      state.vermdisabled = false;
    }

    // individual rules

    // Zweitwohnung nicht in PRE
    if (state.productLine && (state.productLine === "PRE") && (state.zwdisabled === false)) {
      state.zwdisabled = true;
    }

    if (state.sus === true) {
      state.ssrdisabled = true;
    }

    // deselect disabled Zusatzbausteine
    if (state.ssrdisabled === true) state.ssrselected = false;
    if (state.cyberdisabled === true) state.cyberselected = false;
    if (state.zwdisabled === true) state.zwselected = false;
    if (state.vermdisabled === true) state.vermselected = false;
  },
  resetAngebotData: function (state) {
    Object.assign(state, getInitialState());
  },
  saveMatrixState: function (state, { rootState, statePath }) {
    state = getStateRef(rootState, statePath);
    const keys = Object.keys(state.tmpMatrixState);
    keys.forEach((key) => {
      state.tmpMatrixState[key] = state[key];
    });
  },
  recoverMatrixState: function (state, { rootState, statePath }) {
    state = getStateRef(rootState, statePath);
    Object.assign(state, state.tmpMatrixState);
  },
  /**
   * payload: { person: String } // 'vn' or 'mvp'
   */
  addVorversicherung: function (state, { rootState, statePath }) {
    const stateRef = getStateRef(rootState, statePath);
    stateRef.anzahlvorversicherungen++;
  },
  /**
   * payload: { person: String } // 'vn' or 'mvp'
   */
  removeVorversicherung: function (state, { rootState, statePath }) {
    const stateRef = getStateRef(rootState, statePath);
    Object.assign(stateRef.vorversicherung[stateRef.anzahlvorversicherungen - 1], {
      zum: null,
      vorversicherer: "",
      vscheinnr: "",
      von: null
    });
    stateRef.anzahlvorversicherungen--;
  },
  /**
   * param file
   * forcefully remove a file from the files list
   */
  removeFile: function (state, file) {
    let files = state.files;
    let newFiles = files.filter(f => f.id !== file.id);
    if (files.length > newFiles.length) {
      state.files = newFiles;
    }
  },
  loadAngebot(state, angebot) {
    // Since ARB 2020 SuS now has a contractlength of 1 year (not 3). This has to be fixed for offers from 2019
    if (angebot.sus) angebot.contractlength = '1';
    Object.assign(state, getInitialState(), angebot);
  },

  setIdentity(state, user) {
    state.selectedIdentity = user;
    state.selectedTarif = (user.tarifname) ? user.tarifname : "";
  },

  telefonCleanup: (state) => {
    if (state.vn.telefon && state.vn.telefon === '+49') {
      state.vn.telefon = '';
    }
  },
};

const actions = {
  resetAngebotForm(context) {
    context.commit("resetSteps", { page: "privat" });
    context.commit("resetAngebotData");
    context.commit("setIdentity", context.rootState.user);
    window.location.reload();
  },
  loadAngebot(context, angebot) {
    context.commit("resetSteps", { page: 'privat' });
    //for testing loadAngebot set selectTarifAllowed = false in user state
    context.commit("loadAngebot", angebot);
  },
  submitFormular(context, { statePath, formularType }) {
    const stateToSend = Object.assign({}, getStateRef(context.rootState, statePath));

    stateToSend.praemien = {
      produkt: context.getters.productKey(statePath),
      current: context.getters.currentPraemien(statePath),
      monthly: context.getters.customPraemien(statePath)("12"),
      quarterly: context.getters.customPraemien(statePath)("4"),
      halfYearly: context.getters.customPraemien(statePath)("2"),
      yearly: context.getters.customPraemien(statePath)("1"),
      base: context.getters.customPraemien(statePath)("1", "1", 0.0)
    };

    stateToSend.user = context.getters.user;
    stateToSend.user.metadata = Object.assign({}, context.rootState.user.metadata);

    if (!stateToSend.selectedTarif) stateToSend.selectedTarif = context.rootState.user.tarifname;
    const submitTime = getDateWithTimeString(new Date());

    stateToSend.submitTime = submitTime;

    let resultPromise;
    if (formularType === "Antrag") {
      resultPromise = httpService.submitAntrag(stateToSend);
    } else {
      resultPromise = httpService.createAngebot(stateToSend, formularType);
    }
    return resultPromise.then(formular => {
      const setAngebotPayload = {
        rootState: context.rootState,
        statePath,
        angebot: {
          angebotsnummer: formular.angebotsnummer,
          guid: formular.guid,
          pdfpfad: formular.pdfpfad,
          submitTime
        }
      };
      context.commit("setAngebot", setAngebotPayload);
      return formular;
    });
  },
  loadIdentity(context, userId) {
    return httpService.getWhoAmI(userId).then(user => {
      context.commit("setIdentity", user);
      context.dispatch(INIT_PRAEMIEN, context.getters.tarifToLoad);
      return user;
    })
      .catch(() => {
        // if username / vmnr was invalid, reset identity to current user
        context.commit("setIdentity", context.rootState.user);
        context.dispatch(INIT_PRAEMIEN, context.getters.tarifToLoad);
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
